import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import InsuranceForm from './InsuranceForm';

const InsuranceModal = ({ show, onHide, insvalue, edittrigger, onCallParent }) => {
    const isEdit = insvalue && (insvalue.insurance_id || insvalue.id);

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Insurance' : 'Add Insurance'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <InsuranceForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    insvalue={insvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

InsuranceModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    insvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default InsuranceModal;

